import { net } from 'zf-web-infra';
import type { LogoutParams } from './type';

export class LogoutService {

  async logout(params: LogoutParams): Promise<void> {
    await net.post('/api/account/logout', params);
    document.cookie = 'x-access-token=; path=/; SameSite=Lax; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    return;
  }

}
